import { IBookHistory } from '../pages/user/history/type'
type ActionType = 'Lend' | 'Borrow'

export const modalConfig = (item: IBookHistory, type: ActionType) => {
  let description = 'Confirm the action?'
  let visible = false
  let payload = {}
  if (type === 'Lend') {
    switch (item.status) {
      case 'Pending':
        break
      case 'Driver Assigned':
        if (
          !item?.driverReturn &&
          item?.actionStatus?.lend !== 'Book PickedUp'
        ) {
          visible = true
          description = 'Confirm  the Book has been Picked Up ?'
          payload = {
            status: 'Confirm PickUp',
            driverPickUp: item?.pickUpDriver?.id,
          }
        }
        if (item?.driverReturn) {
          visible = true
          description = 'Confirm  the Book has been Received ?'
          payload = {
            status: 'Confirm Delivery',
            driverReturn: item?.returnDriver?.id,
          }
        }
        break

      case 'Delivered':
        break

      case 'Returned':
        break

      default:
        description = 'Confirm the action?'
    }
  }
  if (type === 'Borrow') {
    switch (item.status) {
      case 'Pending':
        visible = false
        break

      case 'Driver Assigned':
        if (
          !item?.driverReturn &&
          item?.actionStatus?.lend === 'Book PickedUp'
        ) {
          visible = true
          description = 'Confirm the Book has been Received ?'
          payload = {
            status: 'Confirm Delivery',
            driverPickUp: item?.pickUpDriver?.id,
          }
        }
        if (item?.driverReturn) {
          visible = true
          description = 'Confirm the Book has been Picked Up ?'
          payload = {
            status: 'Confirm PickUp',
            driverReturn: item?.returnDriver?.id,
          }
        }
        break

      case 'Delivered':
        break

      case 'Returned':
        break

      default:
        description = 'Confirm the action?'
    }
  }

  return { description, visible, payload, type, item }
}
